import ComingSoonPage from "../shared/pages/ComingSoonPage";

import RolesListPage from "./pages/RolesListPage";
import RoleDetailsPage from "./pages/RoleDetailsPage";

export const accessRoutes = [
  {
    path: "/access/roles",
    element: <RolesListPage />,
    roles: ["admin", "past president"],
  },
  {
    path: "/access/roles/:id",
    element: <RoleDetailsPage />,
    roles: ["admin", "past president"],
  },

  // keep permissions page coming soon for now
  {
    path: "/access/permissions",
    element: <ComingSoonPage />,
    roles: ["admin"],
  },
];
